import { render } from "./AddOptionModal.vue?vue&type=template&id=7ca49992&ts=true"
import script from "./AddOptionModal.vue?vue&type=script&lang=ts"
export * from "./AddOptionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__